var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96030(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-030-1{fill:#fff;}.cls-96-030-2,.cls-96-030-3,.cls-96-030-4{fill:none;}.cls-96-030-2,.cls-96-030-3{stroke:#6e6e6e;stroke-linecap:round;stroke-width:1.25px;}.cls-96-030-2{stroke-linejoin:round;}.cls-96-030-3{stroke-miterlimit:10;}.cls-96-030-4{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-030-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-030-2",
    points: "26.49 29.36 31.18 33.29 35.86 29.36 40.54 33.29 45.22 29.36 49.91 33.29 54.6 29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-030-2",
    d: "M62,40.67,49.81,21.54a10.6,10.6,0,0,0-18.27,0L5.91,61.86H90.09L74,39a6.28,6.28,0,0,0-10.19-.09l-9,12.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-030-2",
    points: "60.67 43.56 64.8 46.3 68.92 43.56 73.06 46.3 77.19 43.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-030-2",
    d: "M36.37,61.85l3.55-5.54L44.56,50a5.88,5.88,0,0,1,9.54.09l8.31,11.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-030-2",
    x1: 68.82,
    y1: 22.89,
    x2: 68.82,
    y2: 35.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96-030-2",
    points: "82.08 29.36 68.82 29.36 68.82 22.89 82.08 22.89 80.18 26.13 82.08 29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-030-3",
    d: "M17.63,73.42c4.11,0,4.11-2.63,8.21-2.63s4.11,2.63,8.22,2.63,4.1-2.63,8.21-2.63,4.11,2.63,8.21,2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-030-3",
    d: "M34,82.17c4.11,0,4.11-2.62,8.21-2.62s4.11,2.62,8.22,2.62,4.1-2.62,8.21-2.62,4.11,2.62,8.21,2.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96030);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_030.fafa4044834531ec278b9fe636b249a3.svg";
export { ForwardRef as ReactComponent };